(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widget-section-download", [], factory);
	else if(typeof exports === 'object')
		exports["widget-section-download"] = factory();
	else
		root["widget-section-download"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(577);

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Spacings = exports.Spacings = {
	    NONE: 'none',
	    SMALL: 'small',
	    MEDIUM: 'medium',
	    BIG: 'big'
	};
	Object.freeze(Spacings);
	
	var SPACING_OPTIONS = exports.SPACING_OPTIONS = [{ label: 'None', value: Spacings.NONE }, { label: 'Spacing small', value: Spacings.SMALL }, { label: 'Spacing medium', value: Spacings.MEDIUM }, { label: 'Spacing big', value: Spacings.BIG }];
	
	var SPACING_PREF = exports.SPACING_PREF = 'spacing';

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var Containers = exports.Containers = {
	    NONE: 'none',
	    REGULAR: 'regular'
	};
	Object.freeze(Containers);
	
	var CONTAINER_OPTIONS = exports.CONTAINER_OPTIONS = [{ label: 'None', value: Containers.NONE }, { label: 'Regular', value: Containers.REGULAR }];
	
	var CONTAINER_PREF = exports.CONTAINER_PREF = 'container';

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(543);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Created by Rowan de Zeeuw on 07/09/2018. Used source code from
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Backbase CXPContentWidget to create this extendable version.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Author : Backbase R&D - Amsterdam - New York
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Filename : content.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Description:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  Source code for CXP Universal Content Widget
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  ----------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var bd = window.bd; /* eslint-disable-line no-unused-vars */
	var be = window.be; /* eslint-disable-line no-unused-vars */
	var $ = window.jQuery;
	
	var AbstractIceContentController = function (_AbstractWidgetBaseCo) {
	    _inherits(AbstractIceContentController, _AbstractWidgetBaseCo);
	
	    function AbstractIceContentController(widget) {
	        _classCallCheck(this, AbstractIceContentController);
	
	        //if (be.ice && bd && bd.designMode == 'true') {
	        var _this = _possibleConstructorReturn(this, (AbstractIceContentController.__proto__ || Object.getPrototypeOf(AbstractIceContentController)).call(this, widget));
	
	        !window.__TEST__ && _this.renderIceWidget();
	        //}
	        return _this;
	    }
	
	    _createClass(AbstractIceContentController, [{
	        key: 'renderIceWidget',
	        value: function renderIceWidget() {
	            var _this2 = this;
	
	            if (!be.ice) {
	                $('img[src=""], img:not([src])', this.widget.body).addClass('be-ice-hide-image');
	                $(this.widget.body).addClass('be-ice-widget-rendered');
	                return;
	            }
	            this.widget.iceConfig = be.ice.config;
	
	            if (this.cxpWidget.canEditContent()) {
	                this.cxpWidget.prepareCxpPreferences();
	
	                var templateUrl = String(this.widget.getPreference('templateUrl'));
	
	                var enableEditing = function enableEditing() {
	                    // it is possible to swap template for editorial
	                    // here is an example for image template
	                    if (templateUrl.match(/\/image\.html$/)) {
	                        templateUrl = templateUrl.replace(/\/image\.html$/, '/image-editorial.html');
	                    }
	
	                    return be.ice.controller.edit(_this2.widget, templateUrl).then(function (dom) {
	                        $(_this2.widget.body).find('.bp-g-include').html(dom.dom);
	                        return dom.dom;
	                    });
	                };
	
	                // this widget has property rendering example (template: simple.html)
	                // so we need to refresh widget after property 'title' modified
	                this.widget.model.addEventListener('PrefModified', function (oEvent) {
	                    if (oEvent.attrName === 'title') {
	                        enableEditing();
	                    }
	                }, false, this.widget);
	
	                enableEditing();
	            } else {
	                $(this.widget.body).addClass('be-ice-widget-rendered');
	            }
	        }
	    }]);
	
	    return AbstractIceContentController;
	}(_controller2.default);
	
	exports.default = AbstractIceContentController;

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _cxpConfig = __webpack_require__(544);
	
	var _cxpConfig2 = _interopRequireDefault(_cxpConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AbstractWidgetBaseController = function () {
	    function AbstractWidgetBaseController(widget) {
	        _classCallCheck(this, AbstractWidgetBaseController);
	
	        this.widget = widget;
	        this.widgetPath = window.App.Portal.getWidgetPath(this.widget);
	        this.cxpWidget = new _cxpConfig2.default(widget);
	    }
	
	    _createClass(AbstractWidgetBaseController, [{
	        key: 'getSelector',
	        value: function getSelector(query) {
	            return this.widget.body.querySelector(query);
	        }
	    }, {
	        key: 'getSelectors',
	        value: function getSelectors(query) {
	            return this.widget.body.querySelectorAll(query);
	        }
	    }]);
	
	    return AbstractWidgetBaseController;
	}();
	
	exports.default = AbstractWidgetBaseController;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global window, App */
	
	
	var _containers = __webpack_require__(358);
	
	var _spacings = __webpack_require__(357);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable-next-line no-unused-vars */
	var bd = window.bd;
	/* eslint-disable-next-line no-unused-vars */
	var be = window.be;
	/* eslint-disable-next-line no-unused-vars */
	var b$ = window.b$;
	
	var CxpWidget = function () {
	    function CxpWidget(widget) {
	        _classCallCheck(this, CxpWidget);
	
	        this.widget = widget;
	        this.widgetName = widget.id.replace(/-\d+$/, '');
	
	        this.widget.addEventListener('DOMReady', this.disableClickOnDevelop.bind(this));
	    }
	
	    _createClass(CxpWidget, [{
	        key: 'addHelpTexts',
	        value: function addHelpTexts(propertyKeyTextMap) {
	            var map = Object.keys(propertyKeyTextMap).reduce(function (map, key) {
	                map[key] = { text: propertyKeyTextMap[key] };
	                return map;
	            }, {});
	            this.widget.helpTexts = map;
	        }
	    }, {
	        key: 'onPreferencesSave',
	        value: function onPreferencesSave(event) {
	            // override
	        }
	    }, {
	        key: 'isManageable',
	        value: function isManageable() {
	            var isMasterpage = be && be.utils ? be.utils.module('top.bd.PageMgmtTree.selectedLink')['isMasterPage'] : false;
	            var isInCxpMode = bd.designMode; //Changed be.cmis
	            var isManageable = isInCxpMode && (isMasterpage || this.widget.model.manageable === 'true' || this.widget.model.manageable === '' || this.widget.model.manageable === undefined);
	            return isManageable;
	        }
	    }, {
	        key: 'canEditContent',
	        value: function canEditContent() {
	            /* todo: this is (also) from the backbase content widget, but as I see it, you can only edit the widget if
	            *  you're admin or the creator? Need to check, else change the role here.
	            *  */
	            return this.isManageable() && be.ice.controller && /(?:ADMIN|CREATOR|MANAGER)/.test(this.widget.model.securityProfile);
	        }
	    }, {
	        key: 'prepareCxpPreferences',
	        value: function prepareCxpPreferences() {
	            var _this = this;
	
	            this.widget.addEventListener('preferences-form', function (event) {
	                _this._populatePreferencesForm(event);
	                //*changed
	                if (_this.onCxpPreferencesForm) {
	                    var observer = new MutationObserver(function (mutations) {
	                        var prefForm = document.querySelector('#PreferenceEditorContent');
	                        if (prefForm) {
	                            observer.disconnect();
	                            _this.onCxpPreferencesForm(prefForm);
	                        }
	                    });
	                    observer.observe(document, { attributes: true, childList: true, subtree: true });
	                }
	            });
	            this.widget.addEventListener('preferencesSaved', function (event) {
	                _this.widget.refreshHTML();
	            });
	            this.widget.addEventListener('savePreferenceForm', function (event) {
	                _this.onPreferencesSave(event);
	            });
	        }
	    }, {
	        key: '_populatePreferencesForm',
	        value: function _populatePreferencesForm(event) {
	            var aPrefs = b$.portal.portalModel.filterPreferences(this.widget.model.preferences.array);
	            for (var i = aPrefs.length - 1; i >= 0; i--) {
	                var preferenceItem = aPrefs[i];
	                var prefKey = preferenceItem.name;
	
	                switch (prefKey) {
	                    case _spacings.SPACING_PREF:
	                        this._populateOptions(preferenceItem, _spacings.SPACING_OPTIONS);
	                        break;
	                    case _containers.CONTAINER_PREF:
	                        this._populateOptions(preferenceItem, _containers.CONTAINER_OPTIONS);
	                        break;
	                    default:
	                        this._populateListItems(preferenceItem);
	                }
	            }
	        }
	    }, {
	        key: '_populateOptions',
	        value: function _populateOptions(preferenceItem, options) {
	            preferenceItem.inputType.options = options.map(function (spacing) {
	                return {
	                    label: spacing.label,
	                    value: spacing.value
	                };
	            });
	        }
	    }, {
	        key: '_populateListItems',
	        value: function _populateListItems(preferenceItem) {
	            var prefKey = preferenceItem.name;
	            var sTemplateVariants = this.widget.getPreference(prefKey + 'List');
	
	            if (!sTemplateVariants) {
	                return;
	            }
	
	            var arr = sTemplateVariants.split(',');
	            for (var j = 0, k = 0; j < arr.length; j++, k++) {
	                preferenceItem.inputType.options[k] = {
	                    label: arr[j].trim(),
	                    value: arr[j + 1].trim()
	                };
	                j++;
	            }
	        }
	    }, {
	        key: 'disableClickOnDevelop',
	        value: function disableClickOnDevelop(event) {
	            if (App.Portal.isInDesignMode()) {
	                this.widget.body.querySelectorAll('a').forEach(function (a) {
	                    a.addEventListener('click', function (e) {
	                        return e.preventDefault();
	                    });
	                });
	            }
	        }
	    }]);
	
	    return CxpWidget;
	}();
	
	exports.default = CxpWidget;

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _controller = __webpack_require__(578);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	App.Widgets.setWidgetStarterInNamespace('WidgetSectionDownload', _controller2.default);

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _controller = __webpack_require__(542);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Controller = function (_AbstractIceContentCo) {
	    _inherits(Controller, _AbstractIceContentCo);
	
	    function Controller(widget) {
	        _classCallCheck(this, Controller);
	
	        var _this = _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, widget));
	
	        _this.init(widget);
	        _this.email = "";
	        _this.referenceId = "";
	        return _this;
	    }
	
	    _createClass(Controller, [{
	        key: "init",
	        value: function init(widget) {
	            var _this2 = this;
	
	            var widgetContext = $(widget.htmlNode);
	            var successPage = decodeURI(widget.getPreference('successPage'));
	            var screenName = "DOWNLOAD";
	            var currentMainSection = $(".widget-dfa-download", widgetContext).closest("div[id^=step-]");
	            var currentSubContainer = $(".widget-dfa-download", widgetContext).closest("div[id^=sub-step-]");
	            var currentStep = currentMainSection.attr("id");
	            var currentSubStep = currentSubContainer.attr("id");
	
	            var screenData = {
	                name: screenName,
	                values: {
	                    container: "#" + currentStep + ">.bp-area>#" + currentSubStep,
	                    fieldValue: ""
	                }
	            };
	
	            App.PubSub.subscribe("digitalApplicationData", function (data) {
	                _this2.referenceId = data.referenceId;
	            });
	
	            $(".screenContinue", widgetContext).click(function () {
	                App.PubSub.publish("digitalApplicationForm", screenData);
	                var _email = $(".widget-form-section2 input[name='email']").val();
	                var email = _email.replace(/^(.)(.*)(.@.*)$/, function (_, a, b, c) {
	                    return a + b.replace(/./g, '*') + c;
	                });
	                if (email && _this2.referenceId) {
	                    sessionStorage.setItem("successDetails", JSON.stringify({ email: email, referenceId: _this2.referenceId }));
	                }
	            });
	
	            App.PubSub.subscribe("fileToDownload", function (data) {
	
	                var downloadUrl = "digitalApplication/download?referenceId=";
	                $("#btnDownload", widgetContext).attr("download", "uitfform.pdf");
	                $("#btnDownload", widgetContext).attr("target", "_blank");
	                $("#btnDownload", widgetContext).attr("href", "" + (window.location.href.indexOf('localhost') > -1 ? '/portalserver/' : '/') + downloadUrl + _this2.referenceId);
	
	                $("#btnDownload", widgetContext).click(function () {
	                    setTimeout(function () {
	                        location.replace("" + (window.location.href.indexOf('localhost') > -1 ? '/portalserver/' : '/') + successPage);
	                    }, 5000);
	                });
	            });
	
	            // $("#btnDownload", widgetContext).attr("href", "http://localhost:7777/portalserver/static/features/%5BBBHOST%5D/theme-default/assets/amtc-summary.pdf");
	        }
	    }]);
	
	    return Controller;
	}(_controller2.default);
	
	exports.default = Controller;

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// widget-section-download/scripts/widget-section-download.js